import React, { } from 'react';
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Button,
  Dropdown,
} from '@lockerpm/design';

import {
  KeyOutlined,
  LockOutlined
} from '@ant-design/icons';

function SwitchProject() {
  const { t } = useTranslation();

  const dropdownClick = async (item) => {
    if (item.key === 'password') {
      window.open(process.env.REACT_APP_LOCKER_PASSWORD_URL, '_blank')
    }
  }

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: 'secrets',
            icon: <KeyOutlined />,
            label: <span>{t('sidebar.secrets_manager')}</span>,
          },
          {
            key: 'password',
            icon: <LockOutlined />,
            label: <span>{t('sidebar.password_manager')}</span>
          },
        ],
        defaultSelectedKeys: ['secrets'],
        onClick: dropdownClick
      }}
      placement="bottomLeft"
      trigger={'click'}
    >
      <div>
        <Button
          type="primary"
          ghost
          className='avatar-button'
          shape='circle'
          icon={<LockOutlined/>}
        />
      </div>
    </Dropdown>
  );
}

export default SwitchProject;
